<div id="list-start" class="grid grid-nogutter p-fluid text-center">
    <div class="col-12">
        <p-table #dt [value]="applicationsWithDays()" showGridlines selectionMode="single" [(selection)]="selectedRow" dataKey="id" [resizableColumns]="true"
            [paginator]="true" [rows]="10" [metaKeySelection]="true" [alwaysShowPaginator]="false" class="custom-table"
                 [globalFilterFields]="['plannedStart']">
            <ng-template #caption>
                <div class="flex">
                    <h3 class="text-left" [ngStyle]="{width: '400px'}">{{selectedOption === 'lessOrEqual' ? 'Teljesítések listája' : 'Közelgő események'}}</h3>
                    <!--p-select [options]="filterOptions" (onChange)="doInput()"
                              [fluid]="true" [(ngModel)]="selectedOption"></p-select-->
                    @if (selectedOption === 'lessOrEqual') {
                        <div class="text-right" [ngStyle]="{width: '100%'}">Már teljesített órák száma: {{ completedHours }}</div>
                    } @else {
                        <div class="text-right" [ngStyle]="{width: '100%'}">Közelgő események óraszáma: {{ oncomingHours }}</div>
                    }
                </div>


            </ng-template>
            <ng-template #header>
                <tr>
                    <th pSortableColumn="event.activity.name" pResizableColumn>Tevékenység neve <p-sortIcon field="event.activity.name"/></th>
                    <th pSortableColumn="event.start" pResizableColumn>Esemény időpontja<p-sortIcon field="event.start"/></th>
                    <th pResizableColumn>Órák száma</th>
                    <th pSortableColumn="event.activity.partnerClient.name" pResizableColumn>Partner <p-sortIcon field="event.activity.partnerClient.name"/></th>
                    @if (selectedOption !== 'greaterOrEqual') {
                        <th pResizableColumn>Teljesített</th>
                    }
                    @if (selectedOption === 'greaterOrEqual') {
                        <th pResizableColumn></th>
                    }
                </tr>
                <tr>
                    <th>
                        <p-columnFilter type="text" field="event.title" placeholder="Keresés..." ariaLabel="Keresés" [showMenu]="false" [showClearButton]="false"></p-columnFilter>
                    </th>
                    <th>
                        <p-columnFilter type="date"  field="dayOfEvent" placeholder="Dátum megadása" ariaLabel="Dátum megadása" [showMenu]="false" [showClearButton]="false"></p-columnFilter>
                    </th>
                    <th></th>
                    <th>
                        <p-columnFilter type="text" field="event.activity.partnerClient.name" placeholder="Keresés..." ariaLabel="Keresés" [showMenu]="false" [showClearButton]="false"></p-columnFilter>
                    </th>
                    @if (selectedOption !== 'greaterOrEqual') {
                        <th>
                            <p-columnFilter type="boolean" field="fulfilled"></p-columnFilter>
                        </th>
                    }
                    @if (selectedOption === 'greaterOrEqual') {
                        <th>

                        </th>
                    }
                </tr>
            </ng-template>
            <ng-template #body let-application>
                <tr [pSelectableRow]="application" (dblclick)="viewApplication()">
                    <td>{{application?.event?.activity?.name}}</td>
                    <!--td>{{dateFns.formatDate(application?.event?.start, 'yyyy.MM.dd HH:mm') + ' - ' + dateFns.formatDate(application?.event?.end, 'HH:mm')}}</td-->
                    <td>{{dateFns.formatDate(application?.event?.start, 'yyyy.MM.dd HH:mm') + ' - ' + dateFns.formatDate(application?.event?.end, 'HH:mm')}}</td>
                    <td>{{dateFns.differenceInHours(application?.event?.end, application?.event?.start, {roundingMethod: 'round'})}}</td>
                    <td>{{application?.event?.activity?.partnerClient?.name}}</td>
                    @if (selectedOption !== 'greaterOrEqual') {
                        <td><i class="pi" [ngStyle]="{color: application.fulfilled ? '#43A047' : application.fulfilled===false ? '#E53935' : '#f1e201', fontSize: '1.5rem'}"
                               [ngClass]="application.fulfilled ? 'pi-check-circle' : application.fulfilled === false ? 'pi-times-circle' : 'pi-question-circle'"></i></td>
                    }
                    @if (selectedOption === 'greaterOrEqual') {
                            <td>
                                @if (changesAvailable(application?.event)) {
                                    <i class="pi pi-file-edit mr-3" [ngStyle]="{color: '#43A047', fontSize: '1.2rem'}"
                                       [pTooltip]="'Módosítás'" (click)="viewApplication()"></i>
                                    <i class="pi pi-trash" [ngStyle]="{color: '#E53935' , fontSize: '1.2rem'}"
                                       [pTooltip]="'Lemondás'" (click)="deleteApplication()"></i>
                                } @else {
                                    Nem módosítható/törölhető
                                }
                            </td>
                    }
                    </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<abydos-form-dialog #dialog [newDialogTitle]="'Új foglalás'" [editDialogTitle]="'Foglalás adatai'">
    <ng-template abydosDialogBody let-editedId="editedId" let-editedData="editedData" let-dialog="dialog">
        <app-application-edited-data [dialog]="dialog" [editedId]="editedId" [editedData]="editedData" (formSaved)="editedDataSaved($event)"></app-application-edited-data>
    </ng-template>
</abydos-form-dialog>

<p-toast key="center" />



